import config from '../../../config';

const BlogPostingSchema = (
  headline = '',
  image = '',
  authorName = '',
  publisherName = '',
  publisherLogo = '',
  datePublished = '',
  dateModified = ''
) =>
  JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'BlogPosting',
    headline,
    image,
    author: {
      '@type': 'Person',
      name: authorName,
    },
    publisher: {
      '@type': 'Organization',
      name: publisherName,
      logo: {
        '@type': 'ImageObject',
        url: publisherLogo,
      },
    },
    datePublished,
    dateModified,
    mainEntityOfPage: config.siteUrl,
  });

export default BlogPostingSchema;
